<div class="word">
  <span class="typo-text-2 text-dark">
    {{ `${idx()}. ` }}
  </span>
  <span class="typo-text-2">
    {{ word() }}
  </span>
</div>
